import { LoadingOverlay } from "@mantine/core"
import { DatePickerInput, DateValue } from "@mantine/dates"
import dayjs from "dayjs"
import { motion } from "framer-motion"
import { useEffect, useState } from "react"
import { CollectionQuery } from "../../../models/collection.model"
import { useLazyGetTotalPaymentsQuery } from "../store/dashboard.query"
const TotalCollectedPaymentStatCard = ({
  icon: Icon,
  color
}: any) => {
  const [dateRange, setDateRange] = useState<[DateValue, DateValue]>([
    dayjs().startOf("month").toDate(),
    dayjs().endOf("month").toDate(),
  ])

  const [collectionQuery, setCollectionQuery] = useState<CollectionQuery>({})
const [getTotalPayments, totalLeasePayments] =
    useLazyGetTotalPaymentsQuery()

  useEffect(() => {
    getTotalPayments(collectionQuery)
  }, [collectionQuery])

  useEffect(() => {
   if(dateRange.length > 0) {
		if(dateRange[0] && !dateRange[1]){
			setCollectionQuery({
        filter: [[{field: 'createdAt', operator: '>=', value: dayjs(dateRange[0]).format("YYYY-MM-DD")}]],
				// startDate: dayjs(dateRange[0]).format("YYYY-MM-DD"),
				// endDate:dayjs(dateRange[0]).format("YYYY-MM-DD"),
			})
		}
		if(dateRange[0] && dateRange[1]){
			setCollectionQuery({
        filter: [[
          {field: 'createdAt', operator: '>=', value: dayjs(dateRange[0]).format("YYYY-MM-DD")},
        ],[
          {field: 'createdAt', operator: '<=', value: dayjs(dateRange[1]).format("YYYY-MM-DD")}

        ]
      ]
				// startDate: dayjs(dateRange[0]).format("YYYY-MM-DD"),
				// endDate: dayjs(dateRange[1]).format("YYYY-MM-DD"),
			})
		}
	}
  }, [dateRange])
  return (
    <motion.div
      className="bg-gray-800 col-span-2 bg-opacity-50 backdrop-blur-md shadow-lg rounded-xl border border-gray-700"
      whileHover={{ y: -5, boxShadow: "0 25px 50px -12px rgba(0,0,0,0.5)" }}
    >
      <LoadingOverlay visible={totalLeasePayments.isFetching} />
      <div className="px-4 py-5 sm:p-6">
        <span className="flex items-center justify-between text-sm font-medium text-gray-400">
          <span className="flex items-center w-1/2">
            <Icon className="mr-2" style={{ color }} />
            Collected Lease Payment
          </span>
          <DatePickerInput
            type="range"
            allowSingleDateInRange
            // label="Select date range"
            className="w-1/2"
            valueFormat="MMM D, YYYY"
            popoverProps={{ zIndex: 2000000 }}
            
            
            value={dateRange}
            onChange={setDateRange}
          />
        </span>
        <p className="mt-1 text-3xl font-semibold text-gray-100">
          {parseFloat(totalLeasePayments?.data?.total ?? "0").toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })} ETB
        </p>
      </div>
    </motion.div>
  )
}

export default TotalCollectedPaymentStatCard
